import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCampaign, editCampaign, deleteCampaign, clearCampaignsErrors, fetchProducts, fetchSalesChannels } from '../actions/'; // eslint-disable-line max-len
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditItem from '../components/campaigns/EditCampaign';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  campaigns: PropTypes.object,
  salesChannels: PropTypes.array,
  campaign: PropTypes.object,
  products: PropTypes.array,
  productsMeta: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class CampaignEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchCampaign(this.props.params.id));
    this.props.dispatch(fetchSalesChannels({ limit: 1000 }));
    this.props.dispatch(fetchProducts({ limit: 1000, campaignId: this.props.params.id }));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
      return;
    }
    if (nextProps.campaigns.campaign && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Campaign edited succesfully!',
        error: false,
      });
    }
  }
  deleteCampaign(campaignId) {
    const { campaigns } = this.props;
    campaigns.delete = true;
    this.setState({ campaigns });
    this.props.dispatch(deleteCampaign(campaignId));
    browserHistory.push('/campaigns?page=1');
  }
  saveEditCampaign(campaign) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editCampaign(_.omit(campaign, ['s3Bucket', 'emailBucket'])));
  }
  navigateToView(campaign) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState({ nextState });
    this.props.dispatch(editCampaign(_.omit(campaign, ['s3Bucket', 'emailBucket'])));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearCampaignsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/campaigns/view/${this.props.campaign.id}`);
      } else {
        browserHistory.push('/campaigns?page=1');
      }
    }
  }
  navigation(route) {
    this.props.dispatch(fetchProducts(route));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="campaign component" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditItem
          campaign={this.props.campaign}
          salesChannels={this.props.salesChannels}
          products={this.props.products}
          productsMeta={this.props.productsMeta}
          navigation={route => this.navigation(route)}
          onSave={data => this.saveEditCampaign(data)}
          onDelete={data => this.deleteCampaign(data)}
          onView={data => this.navigateToView(data)}
          getProducts={data => this.props.dispatch(fetchProducts({ limit: 1000, salesChannelId: data.salesChannelId }))} // eslint-disable-line max-len
        />
      </div>
    );
  }
}

CampaignEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    campaigns: state.campaigns,
    campaign: state.campaigns.campaign,
    salesChannels: state.salesChannels.results,
    products: state.products.results,
    productsMeta: state.products.meta,
    error: state.campaigns.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignEditPage));



// WEBPACK FOOTER //
// ./src/containers/CampaignEditPage.js